import { i18next } from '@yola/ws-sdk';
import elementSettings from 'src/js/modules/element-settings';
import isGalleryItem from 'src/js/modules/focal-point/helpers/is-gallery-item';
import AllMediaAppearanceSettingsContainer from '../containers/all-media-appearance-settings-container';
import selectors from '../constants/selectors';
import settingIds from '../constants/setting-ids';

const {
  constants: { triggerTypes },
} = elementSettings;

const getAllMediaSettings = () => ({
  id: settingIds.ALL_MEDIA,
  triggerOn: triggerTypes.SELECT,
  priority: 1,
  settings: {
    querySelector: selectors.MEDIA_CONTAINER,
  },
  matches(element) {
    return isGalleryItem(element);
  },
  tabs: [
    {
      id: 'appearance',
      accordionTitle: i18next.t('All media'),
      component: AllMediaAppearanceSettingsContainer,
    },
  ],
});

export default getAllMediaSettings;
